import React from 'react'
import { ApolloError } from '@apollo/client'

import { Button, useModalContext, ErrorMessage } from '@sketch/components'

import { HideProfileButton } from './HideProfileButton'
import { PublishProfileModal } from '../../modals'
import { Container, Text } from './PublishProfileSection.styles'
import { useGetPublications } from '../../hooks'

export interface WorkspaceSettingsProfileProps {
  workspaceIdentifier: string
  profileIdentifier: string
  error?: ApolloError
  isPublic?: boolean
}

export const PublishProfileSection = (props: WorkspaceSettingsProfileProps) => {
  const { showModal } = useModalContext()
  const { workspaceIdentifier, profileIdentifier, error, isPublic } = props

  const { count } = useGetPublications(workspaceIdentifier)

  if (error) {
    return <ErrorMessage.Generic />
  }

  const getPublicationCountCopy = () => {
    if (count)
      return `${count} Documents are public and available for anyone to
    see.`

    return 'No public documents.'
  }

  return (
    <Container>
      <Text>{getPublicationCountCopy()}</Text>
      {isPublic ? (
        <HideProfileButton identifier={profileIdentifier} />
      ) : (
        <Button
          size="40"
          variant="secondary"
          onClick={() =>
            showModal(PublishProfileModal, { identifier: profileIdentifier })
          }
        >
          Publish Profile…
        </Button>
      )}
    </Container>
  )
}
